import { render, staticRenderFns } from "./MovementModalDetail.vue?vue&type=template&id=b4cbc042"
import script from "./MovementModalDetail.vue?vue&type=script&lang=js"
export * from "./MovementModalDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports